// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___7VhNR","text":"styles__text___39w9Y"};